import React from "react";

export function CarmaIcon(){
  return (
    <path d="M9.5 0L0 10H19L9.5 0Z" fill="#D9D9D9" />
  )
}